// extracted by mini-css-extract-plugin
export default {"wrapper":"profile_wrapper__IALcy","name":"profile_name__ccwqC","seed":"profile_seed__2Vkqg"};